import React from "react";
import MSkeleton from "@/components/ui/atoms/MSkeleton";

/**
 * Placeholder shown in place of the dashboard widgets while the member's
 * stats, family stats and family members are still loading — avoids the
 * jarring effect of sections popping in one-by-one as their own data
 * resolves at different times.
 */
const DashboardSkeleton: React.FC = () => {
  return (
    <div className="flex w-full flex-col items-center gap-6 px-4 py-6">
      {/* Quick actions row */}
      <div className="flex w-full items-center gap-6 py-2">
        {[0, 1, 2].map((i) => (
          <div key={i} className="flex flex-1 flex-col items-center gap-2">
            <MSkeleton className="h-12 w-12 rounded-full" />
            <MSkeleton className="h-3 w-14 rounded-full" />
          </div>
        ))}
      </div>

      {/* Action / feature banner */}
      <MSkeleton className="h-24 w-full rounded-2xl" />

      {/* Family widget */}
      <div className="w-full">
        <MSkeleton className="mb-3 h-4 w-28 rounded-full" />
        <MSkeleton className="h-32 w-full rounded-2xl" />
      </div>

      {/* Family overview stats grid */}
      <div className="grid w-full grid-cols-2 gap-4">
        {[0, 1, 2, 3].map((i) => (
          <MSkeleton key={i} className="h-20 w-full rounded-2xl" />
        ))}
      </div>

      {/* Document send */}
      <MSkeleton className="h-40 w-full rounded-2xl" />
    </div>
  );
};

export default DashboardSkeleton;
